<template>
  <div class="vuestic-tag-group">
    <vuestic-tag
      v-for="field in listDefinition.tableFields"
      :key="field.name"
      :name="field.title"
      :value="value[field.name]"
      :option="option[field.name]"
      :removable="true"
      @remove="removeTag(field.name)"
      v-if="!field.noFilter && value[field.name]"
    />
  </div>
</template>

<script>
import VuesticTag from './VuesticTag.vue'
export default {
  name: 'vuestic-tag-group',
  props: {
    removable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
    },
    option: {
      type: Array,
    },
    type: {
      type: String,
      default: '',
    },
    listDefinition: {
      type: Object,
      default: () => {}
    },
    removeFunction: {
      type: Function
    }
  },
  components: {
    VuesticTag,
  },
  methods: {
    removeTag (tagIndex) {
      this.removeFunction(tagIndex)
    },
  },
}
</script>

<style lang="scss">
.vuestic-tag-group {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-tag/VuesticTagGroup.vue